(function (app) {

    app.provider("disclosureApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function (disclosureId) {
                        return complianceHubApiGateway.getFile("/Disclosures/" + disclosureId, { headers: { "Accept": "application/pdf" } });
                    };

                    //PUTs
                    service.update = function(disclosureId, disclosure) {
                        return complianceHubApiGateway.put("/Disclosures/" + disclosureId, disclosure);
                    };

                    //POSTs
                    service.add = function(file) {
                        return complianceHubApiGateway.postFile("/Disclosures", file);
                    };

                    //DELETEs
                    service.delete = function(disclosureId) {
                        return complianceHubApiGateway.delete("/Disclosures/" + disclosureId);
                    };

                    service.getAgentDisclosure = function (agentId) {
                        return complianceHubApiGateway.get("/Disclosures/Agent/" + agentId);
                    };

                    return service;
                }];
        }]);

})(window.app); //jshint ignore:line